/**
 * FEEDBACK (C1) — o que o COLABORADOR vê: o plano de ação e os compromissos da última pauta CONCLUÍDA (o publicado).
 * Um desenho só para os dois caminhos — "Meu desenvolvimento" (com login) e o link de 7 dias (sem login). Nada da
 * avaliação nem da comparação chega aqui: o servidor só manda o publicado.
 */
import { formatDate } from '@/lib/format-date';
import type { PlanoPublicado as Plano, RotulosDoPlano } from '@/lib/feedback/feedback-store';
import { FB } from '@/lib/feedback/textos';

export function PlanoPublicado({ plano, rotulos }: { plano: Plano; rotulos: RotulosDoPlano }) {
  const valor = (id: string, v: string) => {
    if (!v) return '—';
    if (id === 'prazo') return formatDate(v);
    return rotulos.colunas.find((c) => c.id === id)?.opcoes?.find((o) => o.valor === v)?.rotulo ?? v;
  };
  const compromissos = Object.entries(plano.compromissos).filter(([, v]) => v.trim() !== '');
  return (
    <div className="space-y-6" data-testid="plano-publicado">
      <section className="space-y-3">
        <h2 className="font-display text-lg font-medium text-ink-1 dark:text-ink-dark-1">{FB.titulo_plano}</h2>
        {plano.acoes.length === 0 && <p className="text-sm text-ink-3">—</p>}
        <ul className="space-y-3">
          {plano.acoes.map((a, i) => (
            <li key={i} className="rounded-md border border-line p-4 dark:border-line-dark">
              <dl className="grid grid-cols-1 gap-2 text-sm md:grid-cols-2">
                {rotulos.colunas.map((c) => (
                  <div key={c.id}>
                    <dt className="text-xs text-ink-3 dark:text-ink-dark-3">{c.rotulo}</dt>
                    <dd className="whitespace-pre-line text-ink-1 dark:text-ink-dark-1">{valor(c.id, a[c.id])}</dd>
                  </div>
                ))}
              </dl>
            </li>
          ))}
        </ul>
      </section>
      {compromissos.length > 0 && (
        <section className="space-y-3">
          <h2 className="font-display text-lg font-medium text-ink-1 dark:text-ink-dark-1">{FB.titulo_compromissos}</h2>
          {compromissos.map(([k, v]) => (
            <div key={k} className="space-y-1">
              <p className="text-xs text-ink-3 dark:text-ink-dark-3">{rotulos.compromissos[k] ?? k}</p>
              <p className="whitespace-pre-line text-sm text-ink-1 dark:text-ink-dark-1">{v}</p>
            </div>
          ))}
        </section>
      )}
    </div>
  );
}
